<mat-toolbar style="direction: rtl" >
  <mat-toolbar-row class="play-nav">
    <ngx-slider class="slider" [formControl]="sliderControl" [options]="options"  [manualRefresh]="manualRefresh" ></ngx-slider>
  </mat-toolbar-row>
</mat-toolbar>
